import * as React from "react";
import { useEffect, useState } from "react";

import { RLink } from "../DesignSystem/RLink";
import { TestIds } from "../testIds";

type ErrorSetter = (error: string) => void;

let setError: ErrorSetter | undefined;

export const showError = (error: string): void => {
  if (setError) {
    setError(error);
  }
};

export const ErrorDisplay = (): JSX.Element => {
  const [error, setLocalError] = useState("");

  useEffect(() => {
    setError = setLocalError;
    return () => {
      if (setError === setLocalError) {
        setError = undefined;
      }
    };
  }, []);

  if (error === "") {
    return <div />;
  }

  return (
    <div
      className="fixed top-10 z-[500] w-full bg-[#e65050] p-5 text-2xl font-light text-white"
      data-testid={TestIds.ErrorDisplay}
    >
      <span>{error}</span>
      <span className="absolute right-20 top-5 text-white">
        <RLink onClick={() => setLocalError("")} to="javascript:;">
          X
        </RLink>
      </span>
    </div>
  );
};
